import React from 'react'
import { useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { setStep5, setStep4, setStep3, setStep2, setStep1 } from '../../modules/story/actions'
import editMobile from '../../assetss/img/editMobile.svg'
import c from 'classnames'
import './index.scss'

const MobileNewStoryButton = ({ goTo, isSession }) => {
  const { user } = useSelector(({ session }) => session)
  const { pathname } = useLocation()
  const dispatch = useDispatch()
  const path = pathname.split('/')?.[1]

  const onCreateHandler = () => {
    dispatch(setStep1(null))
    dispatch(setStep2(null))
    dispatch(setStep3(null))
    dispatch(setStep4(null))
    dispatch(setStep5(null))
    goTo('/new-story/step/1')
  }

  return (
    path !== 'story' && path !== 'new-story' && path !== 'chat' && (
      <div
        className={c('btnMobileAddStory', user?.accessKey && 'btnMobileAddStoryUser', !isSession && 'spaccesBottom')}
        onClick={onCreateHandler}
      >
        <img src={editMobile} alt='editMobile' />
      </div>
    )
  )
}

export default MobileNewStoryButton
